import script from "./live-playback.vue?vue&type=script&lang=ts&setup=true"
export * from "./live-playback.vue?vue&type=script&lang=ts&setup=true"

import "./live-playback.vue?vue&type=style&index=0&id=479edc2f&lang=scss&scoped=true"

import exportComponent from "/home/npm/.npm-global/pnpm-global/5/node_modules/.pnpm/vue-loader@16.8.3_b0031e26ad9d3e6a8da3854f251b8894/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479edc2f"]])

export default __exports__